"use strict";
// keep this file in sync with progressSteps.go
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressSteps = void 0;
var ProgressSteps;
(function (ProgressSteps) {
    ProgressSteps["AdditionalDocumentsRequired"] = "additional-documents-required";
    ProgressSteps["AdditionalDocumentsSubmitted"] = "additional-documents-submitted";
    ProgressSteps["AfterRejected"] = "after-rejected";
    ProgressSteps["ApplicationError"] = "application-error";
    ProgressSteps["Approved"] = "approved";
    ProgressSteps["ApprovedPartner"] = "approved-partner";
    ProgressSteps["BusinessInformation"] = "business-information";
    ProgressSteps["ConnectBankAccount"] = "connect-bank-account";
    ProgressSteps["DemographicInformation"] = "demographic-information";
    ProgressSteps["DocumentSigned"] = "document-signed";
    ProgressSteps["DocumentsReviewed"] = "documents-reviewed";
    ProgressSteps["ExistingLoans"] = "existing-loans";
    ProgressSteps["GenericError"] = "generic-error";
    ProgressSteps["MyFinances"] = "my-finances";
    ProgressSteps["NoHitError"] = "no-hit-error";
    ProgressSteps["PersonalInformation"] = "personal-information";
    ProgressSteps["PrequalifiedError"] = "prequalified-error";
    ProgressSteps["Rejected"] = "rejected";
    ProgressSteps["ReviewRequired"] = "review-required";
    ProgressSteps["ReviewRequiredUploadDocuments"] = "review-required-upload-documents";
    ProgressSteps["ReviewRequiredUploadDocumentsBack"] = "review-required-upload-documents-back";
    ProgressSteps["SelectedFinalLoanOffer"] = "selected-final-loan-offer";
    ProgressSteps["SelectedLoanOffer"] = "selected-loan-offer";
    ProgressSteps["SignedLoanAgreementMessage"] = "signed-loan-agreement-message";
    ProgressSteps["StartLoan"] = "start-loan";
    ProgressSteps["SubmittedLoanApplication"] = "submitted-loan-application";
    ProgressSteps["UploadDocuments"] = "upload-documents";
    ProgressSteps["ExistingLoansCompletedBeneficialOwnerInfoNeeded"] = "existing-loans-completed-beneficial-owner-info-needed";
    ProgressSteps["BeneficialOwnersCompleted"] = "beneficial-owners-completed";
})(ProgressSteps = exports.ProgressSteps || (exports.ProgressSteps = {}));
